
(function(){
  document.querySelectorAll('.kk[data-kk-landing]').forEach(function(root){
  // gallery
  var main=root.querySelector('.kk-main-img');
  root.querySelectorAll('[data-kk-thumb]').forEach(function(b){
    b.addEventListener('click',function(){
      if(main){main.src=b.getAttribute('data-kk-thumb');main.removeAttribute('srcset');}
      root.querySelectorAll('[data-kk-thumb]').forEach(function(x){x.setAttribute('aria-pressed',x===b)});
    });
  });
  // coloring demo
  var COLORS=['#FF4F7B','#FF8A2B','#FFC83D','#3CC9A4','#4AA8FF','#9B7BFF','#8B5A3C','#FFFFFF'];
  var current=COLORS[0], pal=root.querySelector('[data-kk-palette]');
  var shapes=[].slice.call(root.querySelectorAll('[data-kk-svg] .kk-fill'));
  COLORS.forEach(function(c,i){
    var b=document.createElement('button'); b.type='button'; b.className='kk-sw'; b.style.background=c;
    b.setAttribute('aria-label',c); b.setAttribute('aria-pressed',i===0);
    b.addEventListener('click',function(){current=c;pal.querySelectorAll('.kk-sw').forEach(function(s){s.setAttribute('aria-pressed',s===b)})});
    pal.appendChild(b);
  });
  shapes.forEach(function(s){s.addEventListener('click',function(){s.setAttribute('fill',current)})});
  root.querySelector('[data-kk-reset]').addEventListener('click',function(){shapes.forEach(function(s){s.removeAttribute('fill')})});
  root.querySelector('[data-kk-random]').addEventListener('click',function(){shapes.forEach(function(s,i){setTimeout(function(){s.setAttribute('fill',COLORS[Math.floor(Math.random()*7)])},i*45)})});
  [[0,'#9B7BFF'],[1,'#FF8A2B'],[2,'#FF8A2B'],[3,'#3CC9A4'],[9,'#FFC83D']].forEach(function(x){if(shapes[x[0]])shapes[x[0]].setAttribute('fill',x[1])});
});
})();
